import { getStoredAccessToken } from './spotifyAuth';

const SPOTIFY_API_BASE = 'https://api.spotify.com/v1';

export const searchTracks = async (query) => {
  const token = await getStoredAccessToken();
  
  if (!token) {
    throw new Error('No Spotify access token available');
  }

  try {
    const response = await fetch(
      `${SPOTIFY_API_BASE}/search?q=${encodeURIComponent(query)}&type=track&limit=10`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      throw new Error('Failed to search tracks');
    }

    const data = await response.json();
    
    // Debug: Log the first track to see what we get
    console.log('First track preview URL:', data.tracks.items[0]?.preview_url);
    console.log('First track data:', data.tracks.items[0]);
    
    // Format the results for easier use
    return data.tracks.items.map(track => ({
  id: track.id,
  name: track.name,
  artist: track.artists.map(a => a.name).join(', '),
  album: track.album.name,
  albumArt: track.album.images[0]?.url || null,
  duration: track.duration_ms,
  previewUrl: track.preview_url,
  uri: track.uri,
  explicit: track.explicit || false  // ADD THIS LINE
}));
  } catch (error) {
    console.error('Error searching tracks:', error);
    throw error;
  }
};

export const getTrack = async (trackId) => {
  const token = await getStoredAccessToken();
  
  if (!token) {
    throw new Error('No Spotify access token available');
  }

  try {
    const response = await fetch(
      `${SPOTIFY_API_BASE}/tracks/${trackId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      throw new Error('Failed to get track');
    }

    const track = await response.json();
    
    return {
      id: track.id,
      name: track.name,
      artist: track.artists.map(a => a.name).join(', '),
      album: track.album.name,
      albumArt: track.album.images[0]?.url || null,
      duration: track.duration_ms,
      previewUrl: track.preview_url,
      uri: track.uri,
      explicit: track.explicit || false
    };
  } catch (error) {
    console.error('Error getting track:', error);
    throw error;
  }
};